import { gql } from '@apollo/client';
export const PARAMETER_FIELDS = gql`
  fragment ParameterFields on ParameterDto {
    id
    parameterId
    value
    code
    label
    state
    parameterType
    visualizationMode
    groupId
    groupName
    remarks
    obligatory
    editable
    verificable
    auditable
    repeatable
    relatedObjectName
    comboCodeLabel
    validationRegex
    relatedObjectType
    childrenParameters {
      id
      parameterId
      value
      code
      label
      state
      parameterType
      visualizationMode
      groupId
      groupName
      remarks
      obligatory
      editable
      verificable
      auditable
      repeatable
      relatedObjectName
      comboCodeLabel
      validationRegex
      relatedObjectType
    }
  }
`;